<template>
  <div>
    <BaseModalForm />
    <BaseModalTable />
    <BaseModalCard />
    <ApprovalFlowModal />
    <ApprovalRecordModal />
  </div>
</template>

<script setup lang="ts">
  import { createAsyncComponent } from '@mts-fe/utils';
  import { BaseModalCard, BaseModalForm, BaseModalTable } from '@mts/components/Base';
  import { ApprovalFlowModal, ApprovalRecordModal } from '@mts/render/components/Approval';
</script>
